<div class="mb-3">
  <div>
    <h1 class="pb-2 border-bottom fw-light" data-testid="customer-edit-heading" i18n>Kunden bearbeiten</h1>

    <kendo-tabstrip>
      <kendo-tabstrip-tab title="Allgemein" i18n-title [selected]="true">
        <ng-template kendoTabContent>
          <div class="content">
            <form [formGroup]="customerForm">
              <div class="row">
                <div class="col-sm-6">
                <app-form-row label="Anrede" i18n-label>
                  <!-- backend #682: the stored value is a code (mr / ms / diverse / company)
                       and the word is ours to render. A native select rather than a Kendo
                       dropdown, deliberately: the option values ARE the codes, so an E2E test
                       picks one with selectOption('mr') without naming a translated word. -->
                  <select
                    id="salutation"
                    formControlName="salutation"
                    data-testid="customer-edit-salutation-select"
                    class="form-select form-select-sm"
                    >
                    <option value="" i18n>— bitte wählen —</option>
                    @for (option of salutationOptions; track option.code) {
                      <option [value]="option.code">{{ option.label }}</option>
                    }
                  </select>
                </app-form-row>
                <app-form-row label="Kundennummer" i18n-label>
                  <input
                    type="text"
                    readonly
                    class="form-control form-control-sm form-control-plaintext"
                    id="customerNumber"
                    formControlName="customerNumber"
                    />
                </app-form-row>

                <app-form-row label="Name 1 / Vorname" i18n-label>
                  <input
                    type="text"
                    formControlName="firstName"
                    class="form-control form-control-sm"
                    />
                </app-form-row>

                  <app-form-row label="Name 2 / Nachname" i18n-label>
                    <input
                      type="text"
                      formControlName="lastName"
                      class="form-control form-control-sm"
                      />
                  </app-form-row>

                    <app-form-row label="Name 3 / Namenszusatz" i18n-label>
                      <input
                        type="text"
                        formControlName="middleName"
                        class="form-control form-control-sm"
                        />
                    </app-form-row>

                      <app-form-row label="Titel" i18n-label>
                        <input
                          type="text"
                          formControlName="title"
                          class="form-control form-control-sm"
                          />
                      </app-form-row>

                      <app-form-row label="Firmenname" i18n-label>
                        <input
                          type="text"
                          formControlName="companyName"
                          class="form-control form-control-sm"
                          />
                      </app-form-row>

                      @if (customerForm.errors && customerForm.errors['invalidCustomerName']) {
                        <div
                          class="invalid-feedback d-block"
                          i18n
                          >
                    Die Angabe eines der Felder Vorname, Nachname oder Firmenname ist erforderlich.
                  </div>
                      }

                      <app-form-row label="Straße" i18n-label>
                        <input
                          type="text"
                          formControlName="street"
                          class="form-control form-control-sm"
                          />
                      </app-form-row>

                      <app-form-row label="PLZ" i18n-label>
                        <input
                          type="text"
                          formControlName="zip"
                          class="form-control form-control-sm"
                          />
                      </app-form-row>

                      <app-form-row label="Ort" i18n-label>
                        <input
                          type="text"
                          formControlName="city"
                          class="form-control form-control-sm"
                          />
                      </app-form-row>

                      <app-form-row label="Region" i18n-label>
                        <input
                          type="text"
                          formControlName="stateOrRegion"
                          class="form-control form-control-sm"
                          />
                      </app-form-row>

                      <app-form-row label="Land" i18n-label>
                        <kendo-dropdownlist
                          [data]="countryItems"
                          formControlName="countryId"
                          textField="name"
                          valueField="id"
                          [valuePrimitive]="true"
                        ></kendo-dropdownlist>
                      </app-form-row>

                      <app-form-row label="E-Mail" i18n-label>
                        <input
                          type="email"
                          formControlName="email"
                          class="form-control form-control-sm"
                          />
                      </app-form-row>

                      <app-form-row label="Telefon" i18n-label>
                        <input
                          type="text"
                          formControlName="phone"
                          class="form-control form-control-sm"
                          />
                      </app-form-row>

                      <app-form-row label="Fax" i18n-label>
                        <input
                          type="text"
                          formControlName="fax"
                          class="form-control form-control-sm"
                          />
                      </app-form-row>
                    </div>

                    <div class="col-sm-6">
                      <app-form-row label="Kundengruppe" i18n-label>
                        <kendo-dropdownlist
                          [data]="customerGroups"
                          formControlName="customerGroupId"
                          textField="name"
                          valueField="id"
                          [valuePrimitive]="true"
                        ></kendo-dropdownlist>
                      </app-form-row>

                        <app-form-row label="Rechnungstyp" i18n-label>
                          <kendo-dropdownlist
                            [data]="invoiceTypes"
                            formControlName="selectedInvoiceType"
                            textField="DisplayName"
                            valueField="Id"
                            [valuePrimitive]="true"
                          ></kendo-dropdownlist>
                          @if (customerForm.errors?.['invoiceTypeMustBeNet']) {
                            <div class="invalid-feedback d-block">
                              <p i18n>Für gewerbliche Händler ohne Kleinunternehmerregelung ist der Rechnungstyp Netto erforderlich.</p>
                            </div>
                          }
                          @if (customerForm.errors?.['invoiceTypeMustBeGross']) {
                            <div class="invalid-feedback d-block">
                              <p i18n>Für diesen Kunden ist der Rechnungstyp Brutto erforderlich. Nur gewerbliche Händler ohne Kleinunternehmerregelung verwenden Netto.</p>
                            </div>
                          }
                        </app-form-row>

                          <app-form-row label="Status" i18n-label>
                            <input
                              name="isActive"
                              id="isActive"
                              class="ms-2 mt-2"
                              type="checkbox"
                              formControlName="isActive"
                              />
                            <label
                              for="isActive"
                              class="col-sm-6 col-form-label col-form-label-sm ms-1"
                              i18n
                              >Kunde ist aktiv</label
                              >
                          </app-form-row>

                            <app-form-row label="Händlerstatus" i18n-label>
                              <input
                                name="isRetailer"
                                id="isRetailer"
                                class="ms-2 mt-2"
                                type="checkbox"
                                formControlName="isRetailer"
                                />

                              <label for="isRetailer" class="col-form-label col-form-label-sm ms-1" i18n
                                >Kunde ist gewerblicher Händler</label
                                >
                            </app-form-row>

                                <app-form-row label="Kleinunternehmer" i18n-label>
                                  <input
                                    name="smallBusinessP19UStG"
                                    id="smallBusinessP19UStG"
                                    class="ms-2 mt-2"
                                    type="checkbox"
                                    formControlName="smallBusinessP19UStG"
                                    />

                                  <label for="smallBusinessP19UStG" class="col-form-label col-form-label-sm ms-1" i18n
                                    >Kleinunternehmer gem. §19 UStG (umsatzsteuerbefreit)</label
                                    >
                                  @if (customerForm.errors?.['smallBusinessRequiresRetailer']) {
                                    <div class="invalid-feedback d-block">
                                      <p i18n>Die Kleinunternehmerregelung gem. §19 UStG kann nur für gewerbliche Händler aktiviert werden.</p>
                                    </div>
                                  }
                                </app-form-row>

                                    <app-form-row label="Benutzerdefinierte Anbieterinformationen" i18n-label>
                                      <input
                                        name="isCustomSellerInfoActive"
                                        id="isCustomSellerInfoActive"
                                        class="ms-2 mt-2"
                                        type="checkbox"
                                        formControlName="isCustomSellerInfoActive"
                                        />
                                      <label
                                        for="isCustomSellerInfoActive"
                                        class="col-form-label col-form-label-sm ms-1"
                                        i18n
                                        >Benutzerdefinierte Anbieterinformationen aktiviert</label
                                        >
                                    </app-form-row>

                                        <app-form-row label="Steuernummer" i18n-label>
                                          <input
                                            type="text"
                                            formControlName="taxId"
                                            class="form-control form-control-sm"
                                            />
                                        </app-form-row>

                                          <app-form-row label="USt.-ID" i18n-label>
                                            <input
                                              type="text"
                                              formControlName="vatRegNo"
                                              class="form-control form-control-sm"
                                              />
                                          </app-form-row>

                                          <!-- Backend #525: the seller-level currency default. Every NEW listing adopts it at
                                               create (derived server-side); existing listings keep their stored currency. -->
                                          <app-form-row label="Standardwährung" i18n-label>
                                            <kendo-dropdownlist
                                              [data]="currencyOptions"
                                              formControlName="defaultCurrency"
                                            ></kendo-dropdownlist>
                                            <small class="form-text text-muted" i18n>
                                              Neue Angebote werden in dieser Währung ausgezeichnet. Bestehende Angebote behalten ihre Währung.
                                            </small>
                                          </app-form-row>

                                          <div>
                                            <app-form-row label="IBAN" i18n-label rowClass="row mt-5 mb-2">
                                              <input
                                                type="text"
                                                formControlName="iban"
                                                class="form-control form-control-sm"
                                                />
                                            </app-form-row>

                                            <app-form-row label="SWIFT / BIC" i18n-label>
                                              <input
                                                type="text"
                                                formControlName="swiftCode"
                                                class="form-control form-control-sm"
                                                />
                                            </app-form-row>

                                              <app-form-row label="Name der Bank" i18n-label>
                                                <input
                                                  type="text"
                                                  formControlName="bankName"
                                                  class="form-control form-control-sm"
                                                  />
                                              </app-form-row>

                                                @if (customerForm.errors && customerForm.errors['incompleteBankAccount']) {
                                                  <div
                                                    class="invalid-feedback d-block"
                                                    i18n
                                                    >
                      Die Angaben der Bankverbindung sind nicht vollständig.
                    </div>
                                                }
                                              </div>

                                              <div class="row mt-5 mb-2">
                                                <label class="col-sm-4 col-form-label col-form-label-sm" i18n>Dokumente</label>
                                              </div>

                                              <div class="row">
                                                <div>
                                                  <app-file-select
                                                    [Files]="fileTransactions"
                                                    [showDownload]="true"
                                                    (fileAdded)="onFileAdded($event)"
                                                    (fileRemoved)="onFileRemoved($event)"
                                                    (fileDownload)="onFileDownload($event)">
                                                  </app-file-select>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <button class="btn btn-secondary m-2" type="button" (click)="onBackClicked()" data-testid="customer-edit-back-button" i18n>
                Zurück
              </button>
                                          <button
                                            class="btn btn-primary m-2"
                                            type="button"
                                            [asyncClick]="submitForm.bind(this)"
                                            [disabled]="saveBtn.disabled || (customerForm.pristine && !filesChanged) || customerForm.invalid"
                                            #saveBtn="asyncClick"
                                            data-testid="customer-edit-submit-button"
                                            i18n
                                            >
                @if (saveBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
                Bestätigen
              </button>
                                        </form>

                                        <!-- Place this div just above or below your <form> tag to show all validation errors at once -->
                                        @if (customerForm.invalid && (customerForm.dirty || customerForm.touched)) {
                                          <div class="alert alert-danger">
                                            <ul class="mb-0">
                                              @if (f['salutation']?.errors?.['required']) {
                                                <li i18n>Die Angabe der Anrede ist erforderlich</li>
                                              }
                                              @if (f['salutation']?.errors?.['salutationCode']) {
                                                <li i18n>Bitte wählen Sie eine Anrede aus der Liste</li>
                                              }
                                              @if (f['firstName']?.errors?.['maxlength']) {
                                                <li i18n>Der Name 1 / Vorname ist zu lang</li>
                                              }
                                              @if (f['lastName']?.errors?.['maxlength']) {
                                                <li i18n>Der Name 2 / Nachname ist zu lang</li>
                                              }
                                              @if (f['middleName']?.errors?.['maxlength']) {
                                                <li i18n>Der Name 3 / Namenszusatz ist zu lang</li>
                                              }
                                              @if (f['title']?.errors?.['maxlength']) {
                                                <li i18n>Der Titel ist zu lang</li>
                                              }
                                              @if (f['companyName']?.errors?.['maxlength']) {
                                                <li i18n>Der Firmenname ist zu lang</li>
                                              }
                                              @if (customerForm.errors?.['invalidCustomerName']) {
                                                <li i18n>Die Angabe eines der Felder Vorname, Nachname oder Firmenname ist erforderlich.</li>
                                              }
                                              @if (f['street']?.errors?.['required']) {
                                                <li i18n>Die Angabe der Straße ist erforderlich</li>
                                              }
                                              @if (f['street']?.errors?.['maxlength']) {
                                                <li i18n>Die Straße ist zu lang</li>
                                              }
                                              @if (f['zip']?.errors?.['required']) {
                                                <li i18n>Die PLZ ist erforderlich</li>
                                              }
                                              @if (f['zip']?.errors?.['maxlength']) {
                                                <li i18n>Die PLZ ist zu lang</li>
                                              }
                                              @if (f['city']?.errors?.['required']) {
                                                <li i18n>Der Ort ist erforderlich</li>
                                              }
                                              @if (f['city']?.errors?.['maxlength']) {
                                                <li i18n>Der Ort ist zu lang</li>
                                              }
                                              @if (f['stateOrRegion']?.errors?.['maxlength']) {
                                                <li i18n>Die Region ist zu lang</li>
                                              }
                                              @if (f['countryId']?.errors?.['required']) {
                                                <li i18n>Die Angabe des Landes ist erforderlich</li>
                                              }
                                              @if (f['countryId']?.errors?.['maxlength']) {
                                                <li i18n>Das Land ist zu lang</li>
                                              }
                                              @if (f['email']?.errors?.['maxlength']) {
                                                <li i18n>Die E-Mail-Adresse ist zu lang</li>
                                              }
                                              @if (f['email']?.hasError('email')) {
                                                <li i18n>Die E-Mail-Adresse ist ungültig</li>
                                              }
                                              @if (f['phone']?.errors?.['maxlength']) {
                                                <li i18n>Die Telefonnummer ist zu lang</li>
                                              }
                                              @if (f['phone']?.hasError('pattern')) {
                                                <li i18n>Die Telefonnummer ist ungültig</li>
                                              }
                                              @if (f['fax']?.errors?.['maxlength']) {
                                                <li i18n>Die Faxnummer ist zu lang</li>
                                              }
                                              @if (f['fax']?.hasError('pattern')) {
                                                <li i18n>Die Telefonnummer ist ungültig</li>
                                              }
                                              @if (f['taxId']?.errors?.['maxlength']) {
                                                <li i18n>Die Steuernummer ist zu lang</li>
                                              }
                                              @if (f['vatRegNo']?.errors?.['maxlength']) {
                                                <li i18n>Die USt.-ID. ist zu lang</li>
                                              }
                                              @if (f['iban']?.errors?.['required']) {
                                                <li i18n>Die Angabe der IBAN-Nummer ist erforderlich</li>
                                              }
                                              @if (f['iban']?.hasError('pattern')) {
                                                <li i18n>Die IBAN-Nummer ist ungültig</li>
                                              }
                                              @if (f['swiftCode']?.errors?.['required']) {
                                                <li i18n>Die Angabe des SWIFT-Codes ist erforderlich</li>
                                              }
                                              @if (f['swiftCode']?.hasError('pattern')) {
                                                <li i18n>Der SWIFT-Code ist ungültig</li>
                                              }
                                              @if (f['bankName']?.errors?.['required']) {
                                                <li i18n>Die Angabe des Banknamens ist erforderlich</li>
                                              }
                                              @if (customerForm.errors?.['incompleteBankAccount']) {
                                                <li i18n>Die Angaben der Bankverbindung sind nicht vollständig.</li>
                                              }
                                              @if (customerForm.errors?.['smallBusinessRequiresRetailer']) {
                                                <li i18n>Die Kleinunternehmerregelung gem. §19 UStG kann nur für gewerbliche Händler aktiviert werden.</li>
                                              }
                                              @if (customerForm.errors?.['invoiceTypeMustBeNet']) {
                                                <li i18n>Für gewerbliche Händler ohne Kleinunternehmerregelung ist der Rechnungstyp Netto erforderlich.</li>
                                              }
                                              @if (customerForm.errors?.['invoiceTypeMustBeGross']) {
                                                <li i18n>Für diesen Kunden ist der Rechnungstyp Brutto erforderlich. Nur gewerbliche Händler ohne Kleinunternehmerregelung verwenden Netto.</li>
                                              }
                                            </ul>
                                          </div>
                                        }

                                      </div>
                                    </ng-template>
                                  </kendo-tabstrip-tab>
                                  <kendo-tabstrip-tab i18n-title title="Berechtigungen">
                                    <ng-template kendoTabContent>
                                      <div class="content">
                                        <app-permission-table [customerId]="customer.id"></app-permission-table>
                                      </div>
                                    </ng-template>
                                  </kendo-tabstrip-tab>
                                </kendo-tabstrip>
                              </div>
                            </div>
